var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SvgAseLogo',{staticClass:"block w-10 h-10 md:w-12 md:h-12",attrs:{"role":"img","alt":"The Automotive Service Excellence logo"}})}
var staticRenderFns = []

export { render, staticRenderFns }